export type PlanningType = 'mijlpaal' | 'communicatie' | 'bijeenkomst' | 'deadline' | 'taak' | 'vergadering' | 'presentatie' | 'rapport' | 'overig';
export type PlanningStatus = 'Gepland' | 'In voorbereiding' | 'In uitvoering' | 'Bevestigd' | 'Voltooid' | 'Afgerond' | 'Geannuleerd' | 'Verlopen';
export type PlanningView = 'timeline' | 'list';
export type WerkCategorie = 'project' | 'raakvlak';

export interface PlanningItem {
  id: string;
  type: PlanningType;
  title: string;
  date: string;
  time: string;
  targetAudience: string;
  channel?: string;
  resource?: string;
  responsible: string;
  status: PlanningStatus;
  location?: string;
  dependencies?: string[];
  description?: string;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  werkCategorie?: WerkCategorie;
}

export interface BackwardPlanningStep {
  name: string;
  days: number;
}

export interface BackwardPlanningTemplate {
  type: 'nieuwsbrief' | 'bijeenkomst' | 'social';
  steps: BackwardPlanningStep[];
}

export const BACKWARD_PLANNING_TEMPLATES: BackwardPlanningTemplate[] = [
  {
    type: 'nieuwsbrief',
    steps: [
      { name: 'Verzending nieuwsbrief', days: 0 },
      { name: 'Eindredactie en goedkeuring', days: -2 },
      { name: 'Vormgeving en opmaak', days: -4 },
      { name: 'Content schrijven', days: -7 },
      { name: 'Redactievergadering', days: -10 },
      { name: 'Input verzamelen', days: -14 }
    ]
  },
  {
    type: 'bijeenkomst',
    steps: [
      { name: 'Bewonersbijeenkomst', days: 0 },
      { name: 'Reminder versturen', days: -3 },
      { name: 'Presentatie afronden', days: -5 },
      { name: 'Locatie definitief', days: -7 },
      { name: 'Uitnodigingen versturen', days: -21 },
      { name: 'Locatie reserveren', days: -28 }
    ]
  },
  {
    type: 'social',
    steps: [
      { name: 'Campagne live', days: 0 },
      { name: 'Content schedulen', days: -1 },
      { name: 'Visuals gereed', days: -3 },
      { name: 'Copy schrijven', days: -5 },
      { name: 'Contentkalender maken', days: -7 },
      { name: 'Strategie bepalen', days: -10 }
    ]
  }
];